import { render, staticRenderFns } from "./RoomDetailView.vue?vue&type=template&id=78b938c3&"
import script from "./RoomDetailView.vue?vue&type=script&lang=ts&"
export * from "./RoomDetailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports